import { formatEuro, formatPercentage } from '@doveit/hammer';
import hash from 'object-hash';
import { Commission, Invoice } from '../../../providers/api/dtos';

export const checkCommissionLimits = (
  newCommission: Commission,
  invoice: Invoice,
  onError: (msg: string) => void,
  commissionToExclude?: Commission,
) => {
  const invoicePaidOrTotalValue = invoice.paidValue ?? invoice.value;

  const commissions = commissionToExclude
    ? invoice.commissions.filter((c) => hash(c) !== hash(commissionToExclude))
    : invoice.commissions;

  const totalPercentage = commissions.reduce((sum, c) => sum + c.percentage, 0);
  const totalFixed = commissions.reduce((sum, c) => sum + c.amount, 0);

  const remainingPercentage = 100 - totalPercentage;
  const remainingFixed = invoicePaidOrTotalValue - totalFixed;

  if (newCommission.amount > remainingFixed) {
    onError(`L'importo inserito di ${formatEuro(newCommission.amount)} (${formatPercentage(newCommission.percentage)}) supera il valore rimanente di ${formatEuro(remainingFixed)} (${formatPercentage(remainingPercentage)}).`);
    return false;
  }

  return true;
};
